import React, { useEffect, useRef } from 'react';
import './GlobeBanner.css';
// Import the background image directly from src/assets
import bgImage from '../assets/images/banner/bg8.jpg';

const GlobeBanner = () => {
  const globeRef = useRef(null);

  useEffect(() => {
    // Import globe.gl dynamically to avoid SSR issues
    import('globe.gl').then(({ default: Globe }) => {
      if (!globeRef.current) return;

      // Kerala marker data
      const keralaMarker = {
        lat: 10.8505,
        lng: 76.2711,
        size: 0.4,
        color: 'red',
        name: 'KERALA'
      };

      // Initialize the globe
      const globe = Globe()
        .globeImageUrl('https://unpkg.com/three-globe@2.42.4/example/img/earth-blue-marble.jpg')
        // Remove the background image from the globe itself
        // .backgroundImageUrl("/images/banner/bg2.jpg")
        .width(globeRef.current.clientWidth)
        .backgroundColor("rgba(0, 0, 0, 0)")
        .height(globeRef.current.clientHeight) // Use container height
        .pointsData([keralaMarker])
        .pointColor('color')
        .pointAltitude(0.1)
        .pointRadius('size')
        // Custom HTML element for the label
        .htmlElementsData([keralaMarker])
        .htmlElement(d => {
          const el = document.createElement('div');
          el.innerHTML = d.name;
          el.className = 'label-element';
          return el;
        })
        .htmlAltitude(0.15)
        (globeRef.current);
      
      // Set up rotation
      const controls = globe.controls();
      controls.autoRotate = true;
      controls.autoRotateSpeed = 0.7;
      // Disable zoom functionality
      controls.enableZoom = false;
      // Disable manual rotation
      controls.enableRotate = false;
      
      // Center view on Kerala and fix altitude
      setTimeout(() => {
        globe.pointOfView({ lat: 10.8505, lng: 76.2711, altitude: 2.0 }, 1000);
      }, 500);

      // Handle resize
      const handleResize = () => {
        globe.width(globeRef.current.clientWidth);
        globe.height(globeRef.current.clientHeight);
      };
      
      window.addEventListener('resize', handleResize);
      
      // Cleanup function
      return () => {
        window.removeEventListener('resize', handleResize);
        globeRef.current.innerHTML = '';
      };
    });
  }, []);

  return (
    <div className="globe-banner">
      {/* Add a separate background div with the image passed as inline style */}
      <div className="globe-background" style={{ backgroundImage: `url(${bgImage})` }}></div>
      <div ref={globeRef} className="globe-container"></div>
    </div>
  );
};

export default GlobeBanner; 